export default __webpack_public_path__ + "static/media/portfolio-cai-2.7e58ebc4.jpg";